class r {
  constructor() {
    this.decimalSeparator = ".";
  }
  zipcode(a) {
    return !!a.match(/^[1-9][0-9]{2}-[0-9]{4}$/);
  }
}
export {
  r as default
};
